import type { ControlPosition, IControl } from 'maplibre-gl';
import { createNewElement } from '../../../lib/createElements';
import ReactGA from 'react-ga4';


/* ****************
 * 索引図ボタンのコントロール
 * ****************/
export class IndexMapControlBtn implements IControl {
  private container: HTMLDivElement | undefined;
  private map: maplibregl.Map | undefined;
  private setState: ((value: boolean) => void) | undefined;
  private state: boolean = false;

  constructor(setState?: (value: boolean) => void, state?: boolean) {
    this.handleClick = this.handleClick.bind(this);
    this.setState = setState; // React の state 更新関数を受け取る
    this.state = state ?? false; // 初期値を設定
  }

  handleClick() {
    if (!this.map) { return; }
    if (this.setState) { this.setState(!this.state); }

    //【GoogleAnalytics】索引図ボタン クリックトラッキング
    ReactGA.event({
      category: "button_click", // カテゴリ（任意の名前）
      action: "click",          // イベントの種類
      label: '地図ボタン/索引図ボタン',       // ボタン名
  });
  }

  onAdd(map: maplibregl.Map) {
    this.map = map;
    // 表示・非表示の切り替えボタンを追加
    const btn = createNewElement('button', { 
        className: 'maplibregl-ctrl-icon',
        childArr: [createNewElement('span', { 
          className: 'small-p',
          textContent: '索引図',
          ariaHidden: 'true'
        })],
        onClick: () => { this.handleClick(); }
      });
      
    const container = createNewElement('div', { 
      className: 'maplibregl-ctrl maplibregl-ctrl-group',
      childArr: [btn]
    });

    // ボタンクリック時の処理
    this.container = container as HTMLDivElement;
    return this.container;
  }

  onRemove() {
    if (this.container && this.container.parentNode) {
      this.container.parentNode.removeChild(this.container);
    }
    this.map = undefined;
  }

  getDefaultPosition(): ControlPosition {
    return 'top-right';
  }
}
